import type { BuilderCompData, BuilderCtxProviderData, BuilderFuncLibData } from '@wix/thunderbolt-symbols'

export type EditableComponentUrls = {
	JSX: string
	SDK: string
	npmModuleName: string
}

export const buildEditorReactComponentMapping = (
	builderComponents: { [componentType: string]: BuilderCompData },
	isEditor: boolean = false,
): Record<string, string> => {
	const mapping: Record<string, string> = {}

	Object.values(builderComponents).forEach((component: BuilderCompData) => {
		const { componentUrl, editorComponentUrl, sdkUrl, moduleSpecifier } = component

		if (moduleSpecifier) {
			if (isEditor && editorComponentUrl) {
				mapping[moduleSpecifier] = editorComponentUrl
			} else if (componentUrl) {
				mapping[moduleSpecifier] = componentUrl
			}

			if (sdkUrl) {
				mapping[`${moduleSpecifier}/sdk`] = sdkUrl
			}
		}
	})

	return mapping
}

export const buildContextProvidersMapping = (
	builderContextProviders: { [providerType: string]: BuilderCtxProviderData },
): Record<string, string> => {
	const mapping: Record<string, string> = {}

	Object.values(builderContextProviders).forEach((contextProviderData: BuilderCtxProviderData) => {
		const { contextSpecifier, componentUrl } = contextProviderData

		if (contextSpecifier?.moduleSpecifier && componentUrl) {
			mapping[contextSpecifier.moduleSpecifier] = componentUrl
		}
	})

	return mapping
}

export const buildFunctionLibrariesMapping = (
	builderFunctionLibraries: { [funcLibType: string]: BuilderFuncLibData },
): Record<string, string> => {
	const mapping: Record<string, string> = {}

	Object.values(builderFunctionLibraries).forEach((funcLibData: BuilderFuncLibData) => {
		const { componentUrl, moduleSpecifier } = funcLibData

		if (moduleSpecifier && componentUrl) {
			mapping[moduleSpecifier] = componentUrl
		}
	})

	return mapping
}
